// Affichées 1.2s entre deux questions, en splash centré.
// Clé = id de la question qu'on vient de répondre.
export const reactions: Record<number, string> = {
  1: "Bien noté ! 📝",
  2: "Ok ok, on voit 😄",
  3: "Intéressant… 🤔",
  4: "Beau programme ! 🤩",
  5: "Tu gères 💪",
  6: "On se rapproche du résultat… 👀",
  7: "Dernière question ! 🏁",
};
